import React from 'react'

const privacyPolicy = () => {
  return (
    <>
        <div className='row'>
            <div className='commanSmallFontHeading col-12 text-left containSection'>Privacy Policy ledscroller.com</div>
            <div className='col-12 containSection'>
                <label>
                    Your privacy is important to us. It is led scroller policy to respect your privacy regarding any information we may collect from you across our website (ledscroller.com) and other sites we own and operate.
                </label>
                <label>
                    We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used.    
                </label>
                <label>
                We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we’ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorized access, disclosure, copying, use or modification.
                </label>
                <label>
                We don’t share any personally identifying information publicly or with third-parties, except when required to by law.
                </label>
                <label>
                Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.
                </label>
                <label>
                You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.
                </label>
                <label>
                Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information. If you have any questions about how we handle user data and personal information, feel free to contact us.
                </label>
                <label>
                This policy is effective as of 01 December 2020.
                </label>
            </div>
            <div className='col-12 text-left'>
                <div className='containSection'>
                    <div className='titleSection'>
                        Mail id : -
                    </div>
                    <div>
                        Please Contact US : usercontactcare@gmail.com
                    </div>
                </div>
            </div>
        </div>
        <style>{`
            .containSection{
                padding-bottom: 25px;   
            }
            .containSection{

            }
            .titleSection{
                font-size: 1.1rem;
                font-weight: 600;
                margin-bottom: 10px;
            }
        `}</style>
    </>
  )
}

export default privacyPolicy;